import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { BarChart3, TrendingUp, DollarSign, Home } from 'lucide-react';

const MLSAnalytics: React.FC = () => {
  return (
    <div className="mls-analytics">
      <Row className="g-4">
        <Col md={6}>
          <Card className="border-0 shadow-sm">
            <Card.Header>
              <h6 className="mb-0">
                <BarChart3 size={18} className="me-2" />
                Market Performance
              </h6>
            </Card.Header>
            <Card.Body>
              <div className="text-center py-5">
                <TrendingUp size={48} className="text-muted mb-3" />
                <h6>Advanced Analytics</h6>
                <p className="text-muted mb-0">
                  Comprehensive market analysis and performance metrics coming soon.
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="border-0 shadow-sm">
            <Card.Header>
              <h6 className="mb-0">
                <DollarSign size={18} className="me-2" />
                Revenue Analytics
              </h6>
            </Card.Header>
            <Card.Body>
              <div className="text-center py-5">
                <Home size={48} className="text-muted mb-3" />
                <h6>Sales Intelligence</h6>
                <p className="text-muted mb-0">
                  Revenue trends and commission analytics will be available here.
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default MLSAnalytics;